import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { post, get } from "helpers/api_helper";
import { COURIERRATE, COURIER } from "helpers/url_helper";
import Select from "react-select";
import { showSuccessAlert, showErrorAlert } from "helpers/alert_helper";

const RateForm = ({cb = () => {}}) => {
    const [selectedCountry, setSelectedCountry] = useState([]);   
    const [courierPatner, setCourierPatner] = useState([]);   
    const [countriesOptions, setCountriesOptions] = useState([]);
    const [citiesOptions, setCitiesOptions] = useState([]);
    const [statesOptions, setStatesOptions] = useState([]);   
    const [selectedCities, setSelectedCities] = useState([]); 
    const [selectedPatner, setSelectedPatner] = useState(null);   
    const [formData, setFormData] = useState({
        title: '',
        pincode: '',
        // courier: '',
        // price: 0,
        // base_price: 0,
        // special_price: 0,
        // additional_per_kg_price: 0,
        // minWeight: '1',
        // maxWeight: '100',
        // transitDays	: '',
        // description: '',
        // description: ''
    });

    // const inintailCall = async() => {
    //     const [locationResponse, patnerResponse] = await Promise.all([
    //         get(`locations/all`),
    //         get(`${COURIER}/options`)
    //     ]);

    //     if (locationResponse.success) setCountriesOptions(locationResponse.data);
    //     if (patnerResponse.success) setCourierPatner(patnerResponse.data);
    // }

    // useEffect(() => {
    //     inintailCall();
    // }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleCountryChange = async(e) => {
        setSelectedCountry(e);
        setStatesOptions(e.states);
        setCitiesOptions([]);
        const p = [];
        e.states.map(v => {
            setCitiesOptions( p => [...p , ...v.cities]);
            p.push(...v.cities.map(v => v.value))
        })
        setSelectedCities(p);
    }

    const handleStateChange = async(e) => {
        setCitiesOptions([]);
        const p = [];
        if(e.length){
            e.map(v => {
                setCitiesOptions( p => [...p , ...v.cities]);
                p.push(...v.cities.map(v => v.value))
            })
        }else{
            selectedCountry.states.map(v => {
                setCitiesOptions( p => [...p , ...v.cities]);
                p.push(...v.cities.map(v => v.value))
            })
        }
        setSelectedCities(p)
    }

    const handlecityChange = (e) => {
        const p = [];
        if(e.length){
            p.push(...e.map(v => v.value));
        }else{
            citiesOptions.map(v => {
                p.push(v.value)
            })
        }
        setSelectedCities(p);
    }

    const handlePatnerChange = (e) => {
        setSelectedPatner(e);
        setFormData({
            ...formData,
            courier: e?.value
        });
    }

    const handelSubmit = async (e) => {
        e.preventDefault();
        
        try{
            // Create JSON payload
            const payload = {
                ...formData,
                courier: selectedPatner?.value,
                pincode: selectedCities.join(','),
            };
            const { success } = await post(COURIERRATE, payload);
            if(success){
                showSuccessAlert('courier rate created successfully', () => {
                    setSelectedCountry([]);
                    // setCourierPatner([]);
                    setCountriesOptions([]);
                    setCitiesOptions([]);
                    setStatesOptions([]);
                    setSelectedCities([]);
                    setSelectedPatner([]);
                    setFormData({
                        title: '',
                        pincode: '',
                        // courier: '',
                        // special_price: '',
                        // price: '',
                        // base_price: '',
                        // additional_per_kg_price: '',
                        // minWeight: '',
                        // maxWeight: '',
                        // transitDays	: '',
                        // description: '',
                        // description: ''
                    });
                });
            } 
        } catch (error) {
            showErrorAlert(error.message || 'Failed to create courier rate');
        }
    };


    return (
        <Row>
            <Col>
                <Card>
                    <CardBody>
                        <h5 className="mb-3"> <i onClick={cb} className="fas fa-arrow-left me-3" role="button" title="Back to All Courier Patners " /> New Zone</h5>
                        <hr />
                        <form onSubmit={handelSubmit}>
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label htmlFor="title">Zone Name</label>
                                        <input type="text" className="form-control" id="title" name="title" value={formData.title} onChange={handleInputChange} placeholder="Zone name" required />
                                    </div>
                                </Col>
                            </Row>
                            {/* <Row className="mt-2">
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="courier">Courier Patner</label>
                                        <Select
                                            id="courier"
                                            value={selectedPatner}
                                            onChange={handlePatnerChange}
                                            options={courierPatner}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder="Courier Patner"
                                        />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="price">Orginal Rate</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" id="price" value={formData.price} name="price" placeholder="Price" required />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="base_price">Serivce rate</label>
                                        <input type="text" className="form-control" id="base_price" name="base_price" value={formData.base_price} onChange={handleInputChange} placeholder="Service Rate" required />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="special_price">Special Rate</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" id="special_price" value={formData?.special_price} name="special_price" placeholder="Special rate" required />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="additional_per_kg_price">Extra Per Kg Rate</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" id="additional_per_kg_price" value={formData?.additional_per_kg_price} name="additional_per_kg_price" placeholder="Extra Per Kg Rate" required />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="minWeight">Min Weight</label>
                                        <input type="text" className="form-control" id="minWeight" name="minWeight" value={formData.minWeight} onChange={handleInputChange} placeholder="Min Weight" required />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="maxWeight">Max Weight</label>
                                        <input type="text" className="form-control" id="maxWeight" name="maxWeight" value={formData.maxWeight} onChange={handleInputChange} placeholder="Max Weight" required />
                                    </div>
                                </Col>
                            </Row>
                             */}
                            <Row>
                                <div className="form-group">
                                    <label htmlFor="special_rate_pincodes">Select County</label>
                                    {/* <input type="text" className="form-control" id="special_rate_pincodes" name="special_rate_pincodes" value={formData.special_rate_pincodes} onChange={handleInputChange} placeholder="Special Rate Pincodes" required /> */}
                                    <Select
                                        value={formData?.pincodes}
                                        onChange={handleCountryChange}
                                        options={countriesOptions}
                                        isMultiple={true}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder="Select Branch Admin"
                                    />
                                </div>
                                <div className="form-group mt-2">
                                    <label htmlFor="special_rate_pincodes">Select States ({statesOptions?.length})</label>
                                    <Select
                                        value={formData?.pincodes}
                                        onChange={handleStateChange}
                                        options={statesOptions}
                                        isMulti={true}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder="Select Branch Admin"
                                    />
                                </div>
                                <div className="form-group mt-2">
                                    <label htmlFor="special_rate_pincodes">Select States ({citiesOptions?.length})</label>
                                    <Select
                                        value={formData?.pincodes}
                                        onChange={handlecityChange}
                                        options={citiesOptions}
                                        isMulti={true}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder="Select Branch Admin"
                                    />
                                </div>
                            </Row>
                            
                            <hr />
                            <Row className="text-end">
                                <Col>
                                    <button className="btn btn-danger me-2 " style={{width: '120px'}} type="button" onClick={cb}>Cancel</button>
                                    <button className="btn btn-primary" style={{width: '120px'}} type="submit">Submit</button>
                                </Col>
                            </Row>
                        </form>
                    </CardBody>
                    
                </Card>
            </Col>
        </Row>
    );
}

export default RateForm;